import type { ModelDefinition } from "@/models.js";

export const amazonNovaModels: ModelDefinition[] = [
	{
		id: "amazon-titan-embed-text-v2",
		name: "Amazon Titan Embed Text V2",
		description:
			"Amazon Titan Text Embeddings V2 model. Supports 1024 dimensions with 8192 token context. Optimized for text retrieval and semantic search.",
		family: "amazon",
		output: ["embedding"],
		releasedAt: new Date("2024-04-30"),
		providers: [
			{
				providerId: "aws-bedrock",
				externalId: "amazon.titan-embed-text-v2:0",
				inputPrice: "0.02e-6",
				outputPrice: "0",
				requestPrice: "0",
				contextSize: 8192,
				streaming: false,
				tools: false,
				jsonOutput: false,
				embeddings: true,
			},
		],
	},
	{
		id: "cohere-rerank-v3-5",
		name: "Cohere Rerank V3.5",
		description:
			"Cohere Rerank 3.5 model on Bedrock. High-quality document reranking for RAG pipelines.",
		family: "cohere",
		output: ["rerank"],
		releasedAt: new Date("2024-11-01"),
		providers: [
			{
				providerId: "aws-bedrock",
				externalId: "cohere.rerank-v3-5:0",
				inputPrice: "1.0e-6",
				outputPrice: "0",
				requestPrice: "0",
				contextSize: 4096,
				streaming: false,
				tools: false,
				jsonOutput: false,
				rerank: true,
			},
		],
	},
	{
		id: "amazon-rerank-v1",
		name: "Amazon Rerank V1",
		description:
			"Amazon Rerank 1.0 model. Cost-effective document reranking for RAG pipelines.",
		family: "amazon",
		output: ["rerank"],
		releasedAt: new Date("2024-12-01"),
		providers: [
			{
				providerId: "aws-bedrock",
				externalId: "amazon.rerank-v1:0",
				inputPrice: "1.0e-6",
				outputPrice: "0",
				requestPrice: "0",
				contextSize: 4096,
				streaming: false,
				tools: false,
				jsonOutput: false,
				rerank: true,
			},
		],
	},
	{
		id: "amazon-nova-pro",
		name: "Amazon Nova Pro",
		description:
			"Amazon's balanced multimodal model with text, image, and video understanding. 300K context.",
		family: "amazon",
		releasedAt: new Date("2024-12-03"),
		providers: [
			{
				providerId: "aws-bedrock",
				externalId: "amazon.nova-pro-v1:0",
				inputPrice: "0.80e-6",
				outputPrice: "3.20e-6",
				requestPrice: "0",
				contextSize: 300000,
				maxOutput: 5120,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
				regions: [{ id: "us-east-1" }],
			},
		],
	},
	{
		id: "amazon-nova-lite",
		name: "Amazon Nova Lite",
		description:
			"Low-cost multimodal model for image, video, and text understanding. 300K context.",
		family: "amazon",
		releasedAt: new Date("2024-12-03"),
		providers: [
			{
				providerId: "aws-bedrock",
				externalId: "amazon.nova-lite-v1:0",
				inputPrice: "0.06e-6",
				outputPrice: "0.24e-6",
				requestPrice: "0",
				contextSize: 300000,
				maxOutput: 5120,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
				regions: [{ id: "us-east-1" }],
			},
		],
	},
	{
		id: "amazon-nova-micro",
		name: "Amazon Nova Micro",
		description: "Text-only model optimized for speed and cost. 128K context.",
		family: "amazon",
		releasedAt: new Date("2024-12-03"),
		providers: [
			{
				providerId: "aws-bedrock",
				externalId: "amazon.nova-micro-v1:0",
				inputPrice: "0.035e-6",
				outputPrice: "0.14e-6",
				requestPrice: "0",
				contextSize: 128000,
				maxOutput: 5120,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
				regions: [{ id: "us-east-1" }],
			},
		],
	},
];
